<template>
	<div class="module-list px-5">
		<app-table
			compact
			class="module-list-table mt-5 is-not-selectable"
			name="apps"
			:columns="columns"
			:column-widths="{ 1: '27%', 2: '24%', 3: '20%', 4: '10%', 5: '8%', 6: '11%' }"
			:current-page="currentPage"
			:last-page="lastPage"
			:rows="rows"
			@on-search-event="onSearch"
			@on-page="changePage"
		>
			<template slot="rows" slot-scope="props">
				<td class="module-main-cell is-not-selectable" v-show="showRow(columns, 1)">
					<div class="module-identity">
						<span class="module-icon">
							<img v-if="props.row.pathIcon" :src="props.row.pathIcon" :alt="props.row.name" @error="hideBrokenImage">
							<v-icon v-else>view_module</v-icon>
						</span>
						<div><strong :title="props.row.name">{{ props.row.name }}</strong><small>ID {{ props.row.id }}</small></div>
					</div>
				</td>
				<td class="module-description-cell" v-show="showRow(columns, 2)">
					<strong :title="props.row.description">{{ props.row.description || 'Sin descripción' }}</strong>
					<small>Descripción del módulo</small>
				</td>
				<td class="module-app-cell" v-show="showRow(columns, 3)">
					<strong>{{ appName(props.row) }}</strong>
					<small>{{ appCode(props.row) }}</small>
				</td>
				<td class="module-resources-cell" v-show="showRow(columns, 4)">
					<strong>{{ resourcesCount(props.row) }}</strong>
					<small>{{ resourcesCount(props.row) === 1 ? 'recurso' : 'recursos' }}</small>
				</td>
				<td class="module-position-cell" v-show="showRow(columns, 5)">
					<span>{{ props.row.position == null ? '—' : props.row.position }}</span>
				</td>
				<td class="module-actions-cell">
					<app-tooltip-button
						color="green"
						icon="edit"
						text="Editar Módulo"
						@click-icon="edit(props.row)"
					/>
					<app-tooltip-button
						color="primary"
						icon="link"
						text="Recursos"
						@click-icon="openResources(props.row)"
					/>
					<app-tooltip-button
						color="red"
						icon="delete"
						text="Eliminar Módulo"
						@click-icon="openModalConfirmation(props.row)"
					/>
				</td>
			</template>
		</app-table>
		<app-confirmation-modal
			:loading="loading"
			:show-modal="modalConfirmation.value"
			@cancel="cancelModalConfirmation"
			@confirm="confirm()"
		/>
	</div>
</template>

<script>
import appConfirmationModal from '@/components/shared/app-confirmation-modal';
import appTooltipButton from '@/components/shared/app-tooltip-button';

function changePage(page) {
	this.$emit('change-page', page);
}

function confirm() {
	this.loading = true;
	this.$http
		.delete(`module/${this.modalConfirmation.selectedRow.id}`)
		.then(() => {
			this.showNotification('Registro eliminado correctamente');
			this.modalConfirmation.value = false;
			this.$emit('on-delete');
		})
		.finally(() => {
			this.loading = false;
		});
}

function edit({ id }) {
	this.goTo('page-module-edit', { params: { id } });
}

function appData(row) {
	return row.app && row.app.data ? row.app.data : {};
}

function appName(row) {
	return this.appData(row).name || 'Sin aplicación';
}

function appCode(row) {
	return this.appData(row).codeApp || '—';
}

function hideBrokenImage(event) {
	const image = event.target;
	image.style.display = 'none';
}

function resourcesCount(row) {
	const resources = row.resource && row.resource.data;
	return Array.isArray(resources) ? resources.length : 0;
}

function onSearch(value) {
	this.$emit('on-search', value);
}

function openResources({ id, name }) {
	this.goTo('page-resource', { params: { moduleId: id, moduleName: name } });
}

function data() {
	return {
		loading: false,
	};
}

export default {
	name: 'module-list',
	components: {
		appConfirmationModal,
		appTooltipButton,
	},
	data,
	props: {
		columns: {
			type: Array,
			required: true,
		},
		currentPage: {
			type: Number,
			default: 0,
		},
		lastPage: {
			type: Number,
			default: 0,
		},
		rows: {
			type: Array,
			required: true,
		},
	},
	methods: {
		appCode,
		appData,
		appName,
		changePage,
		confirm,
		edit,
		hideBrokenImage,
		onSearch,
		openResources,
		resourcesCount,
	},
};
</script>

<style lang="scss">
.module-list-table .table-list {
	table-layout: fixed;

	> tbody > tr,
	> tbody > tr > td { height: 46px !important; min-height: 46px !important; }
	> tbody > tr > td { padding-bottom: 3px !important; padding-top: 3px !important; }
}

.module-main-cell,
.module-description-cell,
.module-app-cell,
.module-resources-cell { text-align: left !important; }

.module-identity { align-items: center; display: flex; gap: 8px; min-width: 0; }
.module-identity > div { display: flex; flex-direction: column; min-width: 0; }
.module-icon { align-items: center; background: #e8f3fc; border-radius: 8px; display: flex; flex: 0 0 30px; height: 30px; justify-content: center; overflow: hidden; }
.module-icon img { height: 20px; object-fit: contain; width: 20px; }
.module-icon .icon { color: #1A4338; font-size: 18px; }
.module-main-cell strong,
.module-description-cell strong,
.module-app-cell strong { color: #304a61; display: block; font-size: 11px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.module-main-cell small,
.module-description-cell small,
.module-app-cell small,
.module-resources-cell small { color: #8496a6; display: block; font-size: 8px; margin-top: 2px; }
.module-resources-cell strong { color: #1A4338; display: block; font-size: 12px; }
.module-position-cell span { background: #edf4fa; border-radius: 6px; color: #49677f; display: inline-block; font-size: 10px; min-width: 26px; padding: 4px 7px; }
.module-actions-cell { padding-left: 4px !important; padding-right: 4px !important; }
</style>



// WEBPACK FOOTER //
// src/components/modules/module-list.vue